


















import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import Emitter from 'element-ui/lib/mixins/emitter.js'
import Button from '@/apps/open/components/Button'
import { IBtnOption, IOption } from './type'

@Component({
  components: {
    Button
  }
})
export default class Dialog extends Mixins(Emitter) {
  options: IOption[] = []
  globalOptions = {}
  keepAliveNames: string[] = []
  visible = false
  broadcast!: Function

  get curOptions () {
    return this.options[this.options.length - 1]
  }

  get opt () {
    return Object.assign({}, this.globalOptions, this.curOptions)
  }

  get body () {
    return this.opt.body
  }

  @Watch('visible')
  onVisibleChange () {
    if (!this.visible) {
      this.options = []
      this.keepAliveNames = []
    }
  }

  @Watch('curOptions')
  onCurOptionsChange () {
    if (!this.curOptions) return
    const body = this.curOptions.body as any
    if (this.curOptions.keepAlive && body.name && !this.keepAliveNames.includes(body.name)) {
      this.keepAliveNames.push(body.name)
    }
  }

  show (options: IOption) {
    this.options.push(options)
    this.visible = true
  }

  close () {
    this.options = []
    this.keepAliveNames = []
    this.visible = false
  }

  back (newOptions = ({} as IOption)) {
    const length = this.options.length
    if (length > 1) {
      this.options.pop()
      const curIndex = this.options.length - 1
      const curOptions = this.options[curIndex]
      if (typeof curOptions.bodyProps === 'object') {
        Object.keys(curOptions.bodyProps).forEach(k => {
          if (!newOptions.bodyProps) {
            newOptions.bodyProps = {}
          }
          if (!(newOptions.bodyProps as any)[k]) {
            ((newOptions.bodyProps as any)[k] = (curOptions.bodyProps as any)[k])
          }
        })
      }
      this.$set(this.options, curIndex, Object.assign({}, curOptions, newOptions))
    } else {
      this.close()
    }
  }

  btnClick (index: number, btn: IBtnOption) {
    if (btn.fn && typeof btn.fn === 'function') {
      btn.fn()
      return
    }
    if (btn.event) {
      this.broadcast((this.body as any).options.componentName, btn.event)
      return
    }
    this.close()
  }

  afterClose () {
    this.opt.afterClose && this.opt.afterClose()
  }

  beforeClose (done: Function) {
    this.opt.beforeClose && this.opt.beforeClose()
    done()
  }
}
